import image from "../assets/l.png";

const INFO = {
	main: {
		title: "IT & Automation Solutions",
		name: "Francisco Viteri",
		email: "francisco_viteri_3@hotmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://www.linkedin.com/in/francisco-viteri-693042b6/",
		github: "https://www.linkedin.com/in/francisco-viteri-693042b6/",
		linkedin: "https://www.linkedin.com/in/francisco-viteri-693042b6/",
		instagram: "https://www.linkedin.com/in/francisco-viteri-693042b6/",
		stackoverflow: "https://www.linkedin.com/in/francisco-viteri-693042b6/",
		facebook: "https://www.linkedin.com/in/francisco-viteri-693042b6/",
	},

	homepage: {
		title: "IT & Electronics Engineer Professional",
		description:
			"I am a self-motivated IT and technical professional with experience in CNC machine operations, electronics, teaching, and IT support including Office 365 administration. With certifications in CompTIA A+ and Circuits and Electronics, I excel at problem-solving, project development, and implementing effective solutions. I am eager to grow my career by applying my skills, continuously learning, and contributing to meaningful projects.",
	},

	about: {
		title: "Technical Operations and IT Specialist",
		description:
			"I have extensive experience in the maintenance and successful operation of CNC machines, ensuring they run efficiently and reliably. I have handled the installation and configuration of security camera systems, providing secure and functional surveillance solutions. In IT support, I have managed Office 365 administration and troubleshooting of hardware and software, ensuring smooth day-to-day operations. Additionally, I have taught electronics and Arduino in a school setting, guiding students through practical applications and hands-on projects. My work spans technical precision, problem-solving, and effective implementation across a variety of technical and educational tasks.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Automation Engineer",
			description:
				"Installation and production with a CNC Biesse Klever and an EdgebanderInstallation and production with a CNC Biesse Klever and an Edgebander",
			logo: image,
			linkText: "View More",
			link: "https://www.linkedin.com/in/francisco-viteri-693042b6/",
		},

		{
			title: "Helpdesk & IT Support Analyst",
			description:
				"Provided technical support for hardware, software, and network issues across multiple departments. Handled troubleshooting, system updates, user onboarding, ticketing workflows, and ensured minimal downtime through proactive IT maintenance.",
			logo: image,
			linkText: "View More",
			link: "https://www.linkedin.com/in/francisco-viteri-693042b6/",
		},

		{
			title: "Robotics & Electronics Instructor",
			description:
				"Taught robotics, programming, and electronics to students using hands-on projects involving microcontrollers, sensors, and automation systems. Developed curriculum, guided student experiments, and led workshops that encouraged STEM learning and innovation.",
			logo: image,
			linkText: "View More",
			link: "https://www.linkedin.com/in/francisco-viteri-693042b6/",
		},

		{
			title: "Healthcare Information Technology Technician",
			description:
				"Supported medical staff with EMR/EHR systems, clinical software, and healthcare devices. Managed HIPAA-compliant IT environments, performed system troubleshooting, installed equipment, and ensured reliable access to critical patient-care technologies.",
			logo: image,
			linkText: "View More",
			link: "https://www.linkedin.com/in/francisco-viteri-693042b6/",
		},

		{
			title: "System Engineer",
			description:
				"Designed, configured, and maintained IT infrastructure including servers, networks, and cloud systems. Implemented automation, monitored performance, improved system reliability, and supported enterprise-level deployments and integrations.",
			logo: image,
			linkText: "View More",
			link: "https://www.linkedin.com/in/francisco-viteri-693042b6/",
		},
	],
};

export default INFO;
